import { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import DebtService from 'services/debt';

const service = new DebtService();

const useList = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({ info: '' });
  const [clickPhone, setClickPhone] = useState('');
  const [showCustomerInfo, setShowCustomerInfo] = useState(false);

  const loadData = async (payload) => {
    const list = await service.customerList(payload);
    setData(Array.isArray(list) ? list : []);
  };

  const delaySearch = useMemo(() => _.debounce(loadData, 500), []);

  useEffect(() => {
    delaySearch(filter);
  }, [filter, delaySearch]);

  useEffect(() => {
    return () => {
      delaySearch.cancel();
    };
  }, [delaySearch]);

  const onSearch = () => {
    delaySearch({});
  };

  const setFilterValue = (name, value) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      [name]: value,
    }));
  };

  const onSaved = async () => {
    loadData();
  };

  const showCustomer = (phone) => {
    setClickPhone(phone);
    setShowCustomerInfo(true);
  };

  return {
    data,
    filter,
    setFilterValue,
    onSearch,
    onSaved,
    showCustomer,
    clickPhone,
    showCustomerInfo,
    setShowCustomerInfo,
  };
};

export default useList;